var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6654 23.6413H45.9987V18.3079C45.9987 10.9479 40.0254 4.97461 32.6654 4.97461C25.3054 4.97461 19.332 10.9479 19.332 18.3079H24.6654C24.6654 13.8813 28.2387 10.3079 32.6654 10.3079C37.092 10.3079 40.6654 13.8813 40.6654 18.3079V23.6413H16.6654C13.732 23.6413 11.332 26.0413 11.332 28.9746V55.6413C11.332 58.5746 13.732 60.9746 16.6654 60.9746H48.6654C51.5987 60.9746 53.9987 58.5746 53.9987 55.6413V28.9746C53.9987 26.0413 51.5987 23.6413 48.6654 23.6413ZM48.6654 55.6413H16.6654V28.9746H48.6654V55.6413ZM32.6654 47.6413C35.5987 47.6413 37.9987 45.2413 37.9987 42.3079C37.9987 39.3746 35.5987 36.9746 32.6654 36.9746C29.732 36.9746 27.332 39.3746 27.332 42.3079C27.332 45.2413 29.732 47.6413 32.6654 47.6413Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lock_open.291ee292ce1d2911c08a9114db924c09.svg";
export { ForwardRef as ReactComponent };